<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { TASK_STATUS_STYLES, taskStatusLabel } from '../cardStatus';

const props = defineProps({
  status: { type: String, required: true },
  // The task type's names for the statuses.
  labels: { type: Object, default: () => ({}) },
  // Draws the status as a call to action: a visit request waiting to be scheduled.
  prominent: { type: Boolean, default: false },
});

const { t } = useI18n();

const style = computed(() => TASK_STATUS_STYLES[props.status]);
</script>

<template>
  <span
    class="inline-flex items-center flex-shrink-0 gap-1 whitespace-nowrap"
    :class="
      prominent
        ? 'h-8 px-3 text-sm rounded-lg bg-n-brand/10 text-n-blue-text'
        : ['h-6 px-2 text-xs font-medium rounded-md', style.class]
    "
    data-testid="task-status"
  >
    <span
      class="flex-shrink-0"
      :class="[style.icon, prominent ? 'size-4' : 'size-3.5']"
    />
    {{ taskStatusLabel(labels, status, t) }}
    <slot />
  </span>
</template>
